"use strict";

/**
 * Returns a list of times between start and end
 *
 * @param {Number} start HHmm
 * @param {Number} end HHmm
 * @return {Array} (730,930) => [730,800,830,900,930]
 */

module.exports = function (start, end) {
  var current = start;
  var res = [];

  while (true) {
    res.push(current);
    if (current % 100 > 0) {
      current = current + 100 - current % 100;
    } else {
      current += 30;
    }
    if (current > end) {
      break;
    }
  }

  return res;
};